<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="10" :sm="24" v-if="!read_only">
        <el-card class="box-card">
          <div slot="header" class="text-center">
            Registro de Vacaciones
          </div>
          <el-form ref="form"
                   label-position="top"
                   :model="form"
                   label-width="120px"
                   :rules="rules">
            <el-row :gutter="10">
              <el-col :md="12">
                <el-form-item label="Fecha de Inicio" prop="init_date">
                  <el-date-picker type="date"
                                  v-model="form.init_date"
                                  :disabled="canEditToSave()"
                                  placeholder="Seleccione una fecha"
                                  style="width: 100%;"
                                  format="dd-MM-yyyy"
                                  value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Fecha de Final" prop="end_date">
                  <el-date-picker type="date"
                                  v-model="form.end_date"
                                  :disabled="canEditToSave()"
                                  placeholder="Seleccione una fecha"
                                  style="width: 100%;"
                                  format="dd-MM-yyyy"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Contratos" prop="contract_id">
                  <el-select v-model="form.contract_id"
                             :disabled="canEditToSave()"
                             placeholder="Seleccionar"  style="width: 100%;">
                    <el-option
                      v-for="item in contracts"
                      :key="item.id"
                      :label="item.start_date +' - '+ item.end_date"
                      :value="item.id">
                      <span style="float: left">{{ item.start_date + " - "+ item.end_date }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item prop="paid" label="Pago o Disfruta">
                  <el-switch
                    v-model="form.paid"
                    :disabled="canEditToSave()"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Pago"
                    inactive-text="Disfruta">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :md="24">
                <el-form-item prop="observation" label="Observación">
                  <el-input
                    type="textarea"
                    :disabled="canEditToSave()"
                    autosize
                    placeholder="Escriba una observación (opcional)"
                    v-model="form.observation">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div role="alert" v-if="error.message" class="el-alert el-alert--error">
              <div class="el-alert__content">
                <span class="el-alert__title is-bold">{{ error.message }}</span>
                <p class="el-alert__description">
                <ul>
                  <li v-for="item in error.errors">{{ item[0] }}</li>
                </ul>
                </p>
              </div>
            </div>

            <el-button @click="clear()">
              Cancelar
            </el-button>

            <el-button type="primary"  style="margin-top: 20px"
                       v-if="!canEditToSave()"
                       :loading="processing" @click="save()">
              <span v-if="!processing">Guardar</span>
              <span v-else>Procesando...</span>
            </el-button>
          </el-form>

        </el-card>
      </el-col>
      <el-col :md="read_only ? 24 : 14" :sm="read_only ? 24 : 14">
        <app-table
          @change-pagination="onChangePagination"
          @change-search="onChangeSearch"
          :total="total">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="init_date"
              label="Fecha I.">
            </el-table-column>
            <el-table-column
              prop="end_date"
              label="Fecha F.">
            </el-table-column>
            <el-table-column
              label="Contrato">
              <template slot-scope="scope">
                <p>{{ scope.row.contract.start_date + " - "}}
                  <span v-if="scope.row.contract.end_date == null">Indefinido</span>
                  <span v-else>{{scope.row.contract.end_date}}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column
              label="Pago o Disfruto">
              <template slot-scope="scope">
                <p>{{ (scope.row.paid) ? "Pago" : "Disfrute" }}</p>
              </template>
            </el-table-column>
            <el-table-column
              :width ="100"
              v-if="!read_only"
              label="">
              <template slot-scope="scope">
                <el-button
                  v-if="canUpdate()"
                  size="mini"
                  type="warning"
                  @click="showDialog(scope.row)"><i class="el-icon-edit"></i></el-button>
                <el-button
                  v-if="!canUpdate()"
                  size="mini"
                  type="primary"
                  @click="showDialog(scope.row)"><i class="fa fa-eye"></i></el-button>
                <el-button
                  v-if="canDelete()"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
              </template>
            </el-table-column>
          </el-table>
        </app-table>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import AppTable from '../../components/Table'
  import {baseApi} from '../../configs/urls'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {params, parseError} from '../../packages/Helpers'
  export default {
    extends: BaseCrud,
    name: 'form-list',
    props: ['employee_id', 'read_only'],
    components: {
      AppTable
    },
    data () {
      return {
        baseUrl: baseApi + '/vacations',
        loadingcontracts: false,
        contracts: [],
        positions: [],
        basePermission: 'vacations',
        form: {
          observation: '',
          paid: false,
          user_id: this.$store.state.auth.id
        },
        rules: {
          init_date: [{ required: true, message: 'La Fecha de Inicio es requerida', trigger: 'blur' }],
          end_date: [{ required: true, message: 'La Fecha de Final es requerida', trigger: 'blur' }],
          cost_center_id: [{ required: true, message: 'El Centro de Costo es requerido', trigger: 'blur' }],
          payroll_id: [{ required: true, message: 'La Planilla es requerida', trigger: 'blur' }],
          position_id: [{ required: true, message: 'La Posición Laborar es requerida', trigger: 'blur' }],
          salary: [
            { required: true, message: 'La Posición Laborar es requerida' }
          ]
        }
      }
    },
    watch: {
      employee_id (id) {
        console.log(id)
        this.clear()
        this.employee_id = id
        this.loadContracts()
        this.refreshData()
      }
    },
    methods: {
      loadContracts () {
        this.loadingcontracts = true
        this.$http.get(baseApi + '/contracts/getlist?employee_id=' + this.employee_id)
          .then(
            (response) => {
              this.contracts = response.body
              this.loadingcontracts = false
            },
            (res) => {
              this._notifyError(parseError(res)[0])
              this.loadingcontracts = false
            }
          )
      },
      _getDeleteTitle (model) {
        return 'Esta seguro que desea elimnar la vacación ' + model.init_date + ' ' + model.end_date
      },
      _beforeRefresh (query) {
        query.employee_id = this.employee_id
      },
      _formatModel (model) {
        if (typeof (model.paid) !== typeof (true)) {
          model.paid = parseInt(model.paid)
        }
        model.paid = (model.paid === 1 || model.paid === true)
        model.contract_id = parseInt(model.contract_id)
      },
      refreshPositions (term) {
        let paramRequest = {
          term,
          limit: 20
        }
        this.$http.get(baseApi + '/positions' + params(paramRequest)).then(
          (response) => {
            this.positions = response.body
          }
        )
      },
      _notifyError (message) {
        this.$notify.error({
          title: 'Error',
          message: message
        })
      },
      _beforeSend (model) {
        model.employee_id = this.employee_id
        return model
      },
      _mounted () {
        this.loadAll()
        this.loadContracts()
      },
      clear () {
        this.$refs.form.resetFields()
      },
      loadAll () {
        this.refreshData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/employees/VacationList.vue